<div class="invite-friends">
  <div class="header">
    <span>{{ 'ref_id' | translate }}</span>
    <i class="icon-error" (click)="close()"></i>
  </div>
  <div class="content">
    <app-customize-input size="xl" [(value)]="referralId" [type]="'text'" [max]="8">
      <div info class="tip">{{ 'valid_in_hour_signup' | translate }}</div>
    </app-customize-input>
    <customize-button
      class="mutual-opacity"
      type="primary-linear"
      width="100%"
      size="medium"
      (click)="submit()"
      [disabled]="!referralId"
    >
      {{ 'apply' | translate }}
    </customize-button>
  </div>
</div>
